import React, { useEffect, useState } from 'react';

import NumberFormat from 'react-number-format';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';

const TotalAssets = props => {
  const classes = useTextFieldStyle();
  const [total, setTotal] = useState(0);

  const { values } = props;

  let valuesToTrack = [
    values.checking_1_b,
    values.checking_2_b,
    values.savings_1_b,
    values.savings_2_b,
    values.stocks_bonds_1_b,
    values.stocks_bonds_2_b,
    values.retirement_1_b,
    values.retirement_2_b,
    values.other_real_estate_b,
  ];

  useEffect(() => {
    let _total = 0;

    valuesToTrack.forEach(value => {
      _total = Number(_total) + Number(value);
    });

    setTotal(_total);
  }, valuesToTrack);

  return (
    <React.Fragment>
      <TextField
        label={'Total Assets'}
        disabled
        variant="outlined"
        InputProps={{
          inputComponent: NumberFormatCustom,
        }}
        // eslint-disable-next-line
        inputProps={{
          value: total,
        }}
        value={total}
        className={classes.root}
        style={{ marginTop: 10 }}
      />
    </React.Fragment>
  );
};

const NumberFormatCustom = props => {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat {...other} getInputRef={inputRef} thousandSeparator isNumericString prefix="$" />
  );
};

const useTextFieldStyle = makeStyles(theme => ({
  root: {
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      border: '2px solid #2684FF !important',
    },
    '& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline': {
      borderWidth: 2,
      borderColor: 'rgba(0, 0, 0, 0.5)',
    },
    '& .MuiFormLabel-root.MuiInputLabel-shrink.Mui-disabled.Mui-disabled.MuiFormLabel-filled': {
      color: 'rgba(0, 0, 0, 0.8)',
      fontWeight: 'bold',
      backgroundColor: '#fff',
      padding: 3,
    },
    '& .MuiInputBase-input.Mui-disabled': {
      backgroundColor: '#E0E0E0',
    },
    width: '100%',
  },
}));

export default TotalAssets;



// WEBPACK FOOTER //
// ./src/components/TotalAssets.js